import { Route, Switch, Redirect } from "react-router-dom";
import styled from "styled-components";

import colors from "constants/palette";
import Login from "pages/auth/Login";
import Register from "pages/auth/Register";
export default function index() {
  const imageId = Math.floor(Math.random() * 6) + 1;

  return (
    <Container>
      <Card>
        <Switch>
          <Route path={"/auth/login"} component={Login} />
          <Route path={"/auth/register"} component={Register} />
          {/* <Route path={"/"} component={Main} /> */}
          <Redirect path={"/"} to={"/auth/login"} />
        </Switch>
      </Card>
      <BackgroundImage src={`/images/background-${imageId}.jpg`} />
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
`;
const BackgroundImage = styled.img`
  background-color: ${colors.primary};
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  filter: grayscale(35%) brightness(65%) saturate(81%) opacity(98%)
    contrast(89%);
  -webkit-filter: grayscale(35%) brightness(65%) saturate(81%) opacity(98%)
    contrast(89%);
  -moz-filter: grayscale(35%) brightness(65%) saturate(81%) opacity(98%)
    contrast(89%);
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(9.5px);
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.083);
  display: block;
  width: 380px;
  max-width: 80vw;
  margin-right: 7vw;

  padding: 24px 32px;
  position: relative;
  bottom: 36px;
`;
